import styles from "./Button.module.css";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	variant?: "primary" | "secondary" | "ghost" | "danger";
	size?: "sm" | "md" | "lg";
	isLoading?: boolean | undefined;
}

export function Button({
	variant = "primary",
	size = "md",
	isLoading,
	children,
	disabled,
	className,
	...props
}: ButtonProps) {
	const classes = [
		styles.button,
		styles[variant],
		styles[size],
		isLoading && styles.loading,
		className,
	]
		.filter(Boolean)
		.join(" ");

	return (
		<button type="button" className={classes} disabled={disabled || isLoading} {...props}>
			{isLoading && <span className={styles.spinner} />}
			{children}
		</button>
	);
}
